import {
  FileBmpIcon,
  FileCsvIcon,
  FileDocIcon,
  FileDocxIcon,
  FileGifIcon,
  FileHtmIcon,
  FileHtmlIcon,
  FileIcon,
  FileJpegIcon,
  FileJpgIcon,
  FileOdtIcon,
  FilePdfIcon,
  FilePngIcon,
  FilePptIcon,
  FilePptxIcon,
  FileTiffIcon,
  FileTxtIcon,
  FileXlsIcon,
  FileXlsxIcon,
  FileZipIcon,
} from '../../../assets/icons';
import React, { ReactElement, SVGProps } from 'react';

const normalSize = {
  width: '20px',
  height: '20px',
};

const largeSize = {
  width: '72px',
  height: '72px',
};

export const FileTypeIcon = (props: {
  svgProps: SVGProps<SVGSVGElement>;
  extension: string;
  large?: boolean;
}): ReactElement => {
  const { svgProps, extension, large } = props;
  const size = large ? largeSize : normalSize;
  const extendedSvgProps = { ...svgProps, width: size.width, height: size.height };
  switch (extension.toLowerCase()) {
    case 'bmp':
      return <FileBmpIcon {...extendedSvgProps} />;
    case 'csv':
      return <FileCsvIcon {...extendedSvgProps} />;
    case 'doc':
      return <FileDocIcon {...extendedSvgProps} />;
    case 'docx':
      return <FileDocxIcon {...extendedSvgProps} />;
    case 'gif':
      return <FileGifIcon {...extendedSvgProps} />;
    case 'htm':
      return <FileHtmIcon {...extendedSvgProps} />;
    case 'html':
      return <FileHtmlIcon {...extendedSvgProps} />;
    case 'jpeg':
      return <FileJpegIcon {...extendedSvgProps} />;
    case 'jpg':
      return <FileJpgIcon {...extendedSvgProps} />;
    case 'odt':
      return <FileOdtIcon {...extendedSvgProps} />;
    case 'pdf':
      return <FilePdfIcon {...extendedSvgProps} />;
    case 'png':
      return <FilePngIcon {...extendedSvgProps} />;
    case 'ppt':
      return <FilePptIcon {...extendedSvgProps} />;
    case 'pptx':
      return <FilePptxIcon {...extendedSvgProps} />;
    case 'tiff':
    case 'tif':
      return <FileTiffIcon {...extendedSvgProps} />;
    case 'txt':
      return <FileTxtIcon {...extendedSvgProps} />;
    case 'xls':
      return <FileXlsIcon {...extendedSvgProps} />;
    case 'xlsx':
      return <FileXlsxIcon {...extendedSvgProps} />;
    case 'zip':
      return <FileZipIcon {...extendedSvgProps} />;
    default:
      return (
        <>
          <FileIcon {...extendedSvgProps} />
          {large && (
            <div className="file-type-icon__container">
              <div
                className="file-type-icon__extension"
                style={{
                  color: props.svgProps.fill,
                }}
              >
                {extension}
              </div>
            </div>
          )}
        </>
      );
  }
};
